import { Info } from "@/icons";
import { Col } from "../Col"
import { Row } from "../Row";
import "./AlertBanner.scss";

type Props = {
    type: 'info' | 'warning' | 'error' | 'success';
    title: string;
    children?: React.ReactNode;
}

export const AlertBanner = ({ type, title, children }: Props) => {

    const iconColor = {
        info: 'text-primary',
        warning: 'text-warning',
        error: 'text-danger',
        success: 'text-success'
    }[type];

    return (
        <Col className={`ui-alert-banner --${type}`} gap="x24" p="x12">
            <Row alignItems="center" gap="x8">
                <Info height={26} width={26} className={iconColor} />
                <h4 className="fs-7 fw-semibold text-grey-black">{title}</h4>
            </Row>
            {children}
        </Col>
    )
}